import { Button, Result } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

export default function FourOThree({ ...props }) {
  const history = useHistory();
  return (
    <Result
      status="403"
      title="Erişim engellendi."
      subTitle="Ulaşmak istediğiniz sayfaya yetkiniz yok. Lütfen sistem yöneticiniz ile iletişime geçiniz."
      extra={
        <Button type="primary" onClick={() => history.goBack()}>
          Geri
        </Button>
      }
    />
  );
}
